module.exports = __webpack_public_path__ + "static/media/fidweb-enrpi-new-client_optimized.d05595ed.png";